import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=e558c7ce&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e558c7ce')) {
      api.createRecord('e558c7ce', component.options)
    } else {
      api.reload('e558c7ce', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=e558c7ce&", function () {
      api.rerender('e558c7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N8JhPQrTrPNJ/JS/comp/IncreaseNumber.vue"
export default component.exports